// extracted by mini-css-extract-plugin
export default {"cancelDialog":"CancelWorkflowDialog_cancelDialog__eBlLS","yes":"CancelWorkflowDialog_yes__u42Ca","no":"CancelWorkflowDialog_no__q7diW"};